import { useQuery } from '@tanstack/react-query';

import { UNDERWRITING_METHODS } from '~/common/constants/api-ids';
import useUrl from '~/common/hooks/useUrl';
import { typedApiClient } from '~/common/util/api-client';

export default function useCreditReportLinks(
  underwritingMethod: 'DU' | 'LPA',
  requestIdentifier?: string,
  enabled = true,
) {
  const { obfuscatedLoanIdentifier } = useUrl();

  return useQuery({
    queryKey: ['credit-report-links', requestIdentifier ?? 'latest'],
    async queryFn() {
      if (underwritingMethod === 'DU') {
        let creditReportUri: string;

        if (requestIdentifier) {
          const duResponse = await typedApiClient.v1.ausCreditReport({
            obfuscatedLoanIdentifier,
            ausMethod: UNDERWRITING_METHODS.DesktopUnderwriter,
            requestIdentifier: {
              requestLdId: 1,
              requestId: requestIdentifier,
            },
          });
          creditReportUri = `${globalThis.globalConfig.edge.baseUrl}/${atob(duResponse.data.requestPath)}`;
        } else {
          const duLatestResponse =
            await typedApiClient.v1.creditValidationGetLatestCreditDocument(
              obfuscatedLoanIdentifier,
            );
          const blob = new Blob([atob(duLatestResponse.data.documentBase64)], {
            type: 'text/plain;charset=utf-8',
          });
          creditReportUri = URL.createObjectURL(blob);
        }

        return {
          creditReportLinks: [
            {
              customerIdentifiers: [
                {
                  customerRecordId: 0,
                },
              ],
              creditReportUri,
              displayName: 'Credit Report',
            },
          ],
        };
      }

      const response = requestIdentifier
        ? await typedApiClient.v1.creditCreditReportDetail(
            obfuscatedLoanIdentifier.obfuscatedLenderDatabaseId,
            obfuscatedLoanIdentifier.obfuscatedLoanRecordId,
            requestIdentifier,
          )
        : await typedApiClient.v1.creditCreditReportLatestList(
            obfuscatedLoanIdentifier.obfuscatedLenderDatabaseId,
            obfuscatedLoanIdentifier.obfuscatedLoanRecordId,
          );

      return response.data;
    },
    retry: 2,
    enabled,
  });
}
